module.exports = __webpack_public_path__ + "img/menu-icon.d9ffa406.png";